// Journal des versions — le plus récent EN TÊTE.
//
// Écrit pour Mehdi et Latifa, pas pour un développeur : chaque ligne dit ce qui
// change POUR EUX. « Refactorisation du module de session » n'apprend rien à un
// pharmacien ; « on ne peut plus rester bloqué dehors sans message » si.

export const CHANGELOG = [
  {
    version: "2.18",
    date: "2026-10-30",
    kind: "correctif",
    title: "Une note de frais ne peut plus porter un montant négatif",
    items: [
      "Le montant d'une note de frais devait seulement être « différent de zéro ». Un montant négatif passait donc, et une avance personnelle de moins 1 000 € validée créditait la cagnotte de plus 1 000 € : de l'argent qui n'avait jamais été avancé, sur un mouvement que l'application ne sait pas reprendre.",
      "Le montant doit désormais être positif, à la saisie comme sur le serveur. Les notes de frais n'ayant encore jamais servi, aucune cagnotte existante n'est touchée : rien à vérifier de votre côté.",
      "Pour corriger une note déjà validée, le chemin reste l'annulation avec son motif, ou un ajustement motivé de la cagnotte — jamais une note au montant négatif.",
    ],
  },
  {
    version: "2.17",
    date: "2026-10-30",
    kind: "correctif",
    title: "Les boutons de siphonnage qui ne peuvent rien faire sont devenus inactifs",
    items: [
      "Les boutons rangés sous « Voir », dans « Siphonner les factures », restaient cliquables. Un clic lançait une collecte qui finissait en erreur et laissait une ligne rouge dans le journal, alors que rien ne pouvait la satisfaire : la source est bien connue, mais son connecteur n'est pas encore écrit.",
      "Ils sont désormais grisés et inactifs, avec l'explication au survol de la souris. Plus de collecte lancée pour rien.",
    ],
  },
  {
    version: "2.16",
    date: "2026-10-29",
    kind: "correctif",
    title: "Siphonner les factures : seuls les boutons qui marchent sont affichés",
    items: [
      "Le panneau « Siphonner les factures » affichait trente-et-un boutons, dont vingt-huit qui ne peuvent rien collecter : leur connecteur n'est pas encore écrit. Celui de la boîte facture@ y était au même rang, noyé au milieu, et devenait introuvable.",
      "Désormais, seuls les boutons qui fonctionnent sont affichés : la boîte facture@, GSA et SY. Les autres sont rangées sous un bouton « Voir », avec la raison écrite à côté. Un clic les ramène si vous voulez la liste complète.",
    ],
  },
  {
    version: "2.15",
    date: "2026-09-30",
    kind: "profonde",
    title: "Remise grossiste : la remise arrière calculée sur les lignes SANS remise, la règle constatée chez Alliance",
    items: [
      "Nouveau réglage « Assiette » en haut de l'écran. Par défaut : les lignes sans remise sur facture. Une ligne déjà remisée (remise laboratoire, partenariat) sort du calcul, un générique non remisé y entre. C'est la règle mesurée chez Alliance sur 18 mois : 3,8 % des achats sans remise du mois précédent.",
      "Les barèmes Alliance deviennent : promis 3,8 %, versé sur les relevés 3,26 %, avec régularisations 3,54 % (Théâtres, 12 mois). Le barème CERP garde 4,75 % et 20 €/boîte, sur la même assiette.",
      "L'ancienne assiette « tout sauf les génériques » reste disponible, avec son réglage de part de génériques. Les barèmes gardés dans votre navigateur repartent des nouveaux exemples ; vos réglages génériqueurs sont conservés.",
    ],
  },
  {
    version: "2.14",
    date: "2026-09-30",
    kind: "correctif",
    title: "Remise grossiste : chaque grossiste avec sa propre liste de génériques",
    items: [
      "Nouveau réglage par barème : « dont remisés quand même : … % des génériques ». Cet écran retire tous les génériques du référentiel officiel, alors qu'Alliance en remise une partie (sa liste est plus courte). Les barèmes Alliance sont pré-réglés à 38 %, mesuré aux Théâtres ; CERP reste à 0 % tant qu'il n'a pas dit par écrit quels génériques il exclut.",
      "Une ligne « génériques remisés quand même » apparaît dans le tableau et sur la fiche PDF. Le taux promis par Alliance n'est plus sous-estimé d'environ 7 %.",
    ],
  },
  {
    version: "2.13",
    date: "2026-09-30",
    kind: "correctif",
    title: "Remise grossiste : le barème Alliance « avec régularisations » corrigé (3,34 %, pas 3,64 %)",
    items: [
      "La version 2.12 comptait en entier une régularisation qui couvre aussi des mois d'avant la période. Rattachée aux seuls mois qu'elle concerne, la remise Alliance réellement reçue aux Théâtres fait 3,34 % des achats hors génériques (≈ 3,0 % de tous les achats), pas 3,64 %.",
      "L'encadré « Promesse et vérité » le dit, et rappelle que rien de ce versement n'est écrit : ni décompte des régularisations, ni contrat qui fixe le taux.",
      "Nouvel avertissement sous le tableau (et sur la fiche PDF) : cet écran retire les génériques du référentiel officiel, alors qu'Alliance en retire moins. Son assiette est environ 7 % plus large, donc un taux Alliance saisi ici sous-estime ce qu'il verserait.",
    ],
  },
  {
    version: "2.12",
    date: "2026-09-30",
    kind: "ajout",
    title: "Remise grossiste : le taux promis face au montant réellement versé",
    items: [
      "Trois barèmes Alliance au choix : le taux promis (3,6 %), ce qui est réellement versé sur les relevés (3,08 %, mesuré aux Théâtres sur 12 mois) et ce qui est versé en comptant les régularisations arrivées en banque (3,64 %).",
      "Nouveau champ « dividende / remise complémentaire » sur chaque barème, pour une ristourne de coopérative ou une prime versée à part. Il s'ajoute au total, sur une ligne à lui.",
      "Un encadré « Promesse et vérité » explique où lire le vrai chiffre chez Alliance, ce qu'il ne faut pas additionner, et comment vérifier une offre concurrente.",
    ],
  },
  {
    version: "2.11",
    date: "2026-09-30",
    kind: "nouveau",
    title: "Depuis l'accueil d'EtikID : les factures ou les échéances d'un laboratoire en un clic",
    items: [
      "« Retrouver une facture » et « Voir les échéances et relances » de l'accueil d'EtikID ouvrent le Bureau directement sur « Toutes » ou « Échéances à venir », déjà filtré sur le laboratoire tapé. Sans laboratoire : toutes les échéances à venir, par date.",
      "Un bandeau dit ce qui a été filtré. Si aucun de vos fournisseurs ne porte ce nom, il le dit aussi, et la liste n'est pas filtrée — « EA Pharma » ne ramène pas Pharmazon.",
    ],
  },
  {
    version: "2.10",
    date: "2026-09-26",
    kind: "nouveau",
    title: "Analyse → Remise grossiste : comparer deux barèmes sur vos vrais achats",
    items: [
      "Deux barèmes de remise arrière face à face (par exemple Alliance 3,6 % contre CERP 4,75 % plafonné) calculés boîte par boîte sur vos achats réels d'un grossiste, sur 12 mois par défaut. Modifiez une tranche ou un taux : le résultat suit immédiatement, pour tester une contre-proposition avant de la faire.",
      "Un bloc génériqueurs, sur le modèle Biogaran : remise sur facture garantie (33 % par exemple, hors la part à 2,5 % sur facture) plus remise arrière sur tout le brut (24 %, 28 % avec UniQ). Deux taux à régler, actuel et proposé ; l'écran donne les remises annuelles et le gain. Sans taux renseigné, il écrit « taux inconnu », jamais 0 €.",
      "« Fiche PDF » sort une page à envoyer à un confrère, avec les hypothèses du calcul écrites dessus.",
    ],
  },
  {
    version: "2.9",
    date: "2026-09-19",
    kind: "nouveau",
    title: "Pilotage : la marge réalisée par laboratoire, enfin affichée",
    items: [
      "En bas de l'onglet Pilotage : pour une période au choix (2025 complet, 2026 en cours…), ce que chaque laboratoire ou grossiste vous a réellement rapporté — CA couvert, marge en euros, taux, part de votre marge totale. Le calcul existait en base depuis le 3 septembre ; aucun écran ne le montrait.",
      "Ce n'est pas le taux de marge du haut de l'écran (théorique, sur prix public) : ici ce sont vos ventes réelles du LGO croisées avec le coût réellement facturé. L'écran le dit, pour qu'on ne compare pas deux choses différentes.",
      "Un laboratoire dont le coût n'est pas connu est compté à part, jamais affiché avec une marge de 100 %.",
    ],
  },
  {
    version: "2.8",
    date: "2026-09-19",
    kind: "correctif",
    title: "« Voir » n'accuse plus le serveur quand une facture n'a pas de fichier",
    items: [
      "973 factures DigiPharmacie (avril à août) portaient une référence de PDF qui ne correspondait à aucun fichier : le bouton ouvrait un onglet vide puis « Le serveur n'a pas pu traiter la demande ». Ces références ont été retirées ; la colonne affiche « — », comme pour toute facture sans PDF.",
      "Si le cas se reproduit, le message le dit désormais : « aucun fichier dans le stockage pour cette facture — le PDF est dans HubPharma ou dans la boîte mail ».",
      "Marge par période : le calcul lisait une colonne de prix renommée depuis le 13 août — corrigé sur GitHub à l'époque, mais jamais mis en ligne. Cette version l'embarque.",
    ],
  },
  {
    version: "2.5",
    date: "2026-08-13",
    kind: "correctif",
    title: "Sept de vos sources de factures étaient introuvables dans l'écran Collecteurs",
    items: [
      "CERP, OCP, UPSA, HubPharma, DigiPharmacie, SY et votre boîte facture@ n'apparaissaient nulle part : ni dans les collecteurs actifs, ni dans l'annuaire des inactifs. Vous ne pouviez donc pas leur donner vos identifiants — et sans identifiants, elles ne pouvaient pas apparaître.",
      "Elles sont maintenant toutes affichées, avec un bouton « Configurer ». C'est ce qui débloque la reprise automatique des factures SY.",
      "Une carte sans identifiant enregistré le dit désormais franchement : « À configurer ». Elle annonçait « Configuré » alors que rien ne l'était.",
      "Votre boîte facture@ ne vous propose plus de saisir un mot de passe : il n'y a rien à y saisir, elle est lue automatiquement.",
    ],
  },
  {
    version: "2.4",
    date: "2026-08-11",
    kind: "ajout",
    title: "Les charges ne sont plus comptées comme des achats de marchandises",
    items: [
      "Un loyer, un salaire, une taxe, une note de frais au supermarché ne sont pas des achats de médicaments. Ils étaient pourtant additionnés aux vôtres dans les totaux mensuels, le classement des fournisseurs et la répartition par canal.",
      "Vous pouvez maintenant déclarer une bonne fois qu'un fournisseur n'est pas un fournisseur de marchandises. Toutes ses factures, passées et à venir, sortent d'elles-mêmes des chiffres d'achat.",
      "Un fournisseur peut faire les deux — Pharmavance vous facture du groupement et, 26 fois, de la marchandise. Une facture précise peut donc être corrigée à la main sans changer la règle générale.",
      "Elles ne disparaissent nulle part : la liste et l'échéancier les gardent, signalées par une pastille, parce qu'une charge se paie comme le reste. Une ligne sous les totaux dit combien elles pèsent.",
      "Les remises arrière (vos avoirs) restent comptées dans vos achats, en négatif : elles réduisent votre coût, c'est leur rôle.",
      "Les factures de personnel sortent de l'écran Marques : elles y affichaient des noms de salariés à côté de produits, et pouvaient partir sur une fiche imprimée.",
    ],
  },
  {
    version: "2.3",
    date: "2026-08-10",
    kind: "ajout",
    title: "Étiquetage : répondre code par code quand le groupe n'a pas de réponse",
    items: [
      "Un groupe comme « CREME » rassemblait 86 lignes et 8 marques différentes — Avril, Bioderma, CeraVe, La Rosée. Lui demander UNE marque était une question sans réponse. Chaque groupe a maintenant un bouton « Détailler » : vous cochez les lignes qui vont ensemble, vous tapez la marque une fois, vous validez. Puis les suivantes.",
      "Ce qui est traité disparaît de la liste au lieu de rester coché : impossible de le re-sélectionner par mégarde au geste suivant.",
      "Un groupe traité en partie reste affiché avec ce qu'il vous reste à faire, et sort tout seul quand il ne reste plus rien. Vous ne perdez jamais un reliquat de vue.",
      "La file ne vous propose plus les médicaments sur ordonnance ni les produits que le catalogue connaît déjà : 93,5 % de vos achats sont désormais rattachés à une marque sans que vous ayez eu à les saisir.",
    ],
  },
  {
    version: "2.2",
    date: "2026-08-09",
    kind: "ajout",
    title: "Conditions dégradées : de l'alerte à la réclamation",
    items: [
      "Chaque condition dégradée dit désormais SUR QUELLE FACTURE elle a été constatée, contre quelle facture précédente, et COMBIEN elle vous a coûté sur la livraison. Une remise qui baisse de 5 points ne se conteste pas ; « sur votre facture FA-4471 du 12/07, 24 unités, 10,08 € de plus qu'au tarif du 03/06 » ne se conteste pas non plus.",
      "Le bouton « Garder » arrive sur ces alertes, et la fiche imprimée est découpée PAR FOURNISSEUR : une page par destinataire, prête à envoyer. Deux fournisseurs concurrents ne lisent plus les conditions l'un de l'autre.",
      "La liste s'arrêtait à 300 lignes sans le dire — elle annonce maintenant le total réel quand elle est tronquée. Vous saviez qu'il y avait 300 alertes ; vous ne pouviez pas savoir s'il y en avait 300 ou 3 000.",
      "Les alertes sont classées par ce qu'elles vous coûtent, tous types confondus. Avant, tous les frais de port passaient devant toutes les baisses de remise, si grosses soient-elles — une remise perdue pouvait ne jamais apparaître.",
      "Nouveau filtre « opposables seulement » : ne garder que les alertes dont les deux relevés viennent d'une vraie facture. Les autres, comparées à un catalogue, restent visibles mais ne peuvent pas fonder une réclamation.",
      "Écran « Marques » : les médicaments sur ordonnance ne vous sont plus proposés à étiqueter. Leur marque ne se négocie pas, et leur nom est déjà dans le libellé — l'écran vous présentait Lynparza et Stelara en premier alors qu'il n'y avait rien à y gagner. Votre file commence maintenant par Avène, Gallia, Modilac.",
    ],
  },
  {
    version: "2.1",
    date: "2026-08-06",
    kind: "profonde",
    title: "Refonte : pilotage, frais, et des chiffres auxquels se fier",
    items: [
      "Nouvel écran « Aujourd'hui » : en cinq secondes, vous savez si quelque chose demande votre attention.",
      "Nouvel écran « Canaux » : l'app surveille chaque source de factures et vous alerte quand l'une se tait — un canal muet passait jusqu'ici totalement inaperçu.",
      "Nouvel écran « Pilotage » : votre taux de marge dans le temps, avec la part de vos achats réellement couverte par le calcul. Quand vos sources de données changent, l'app refuse de comparer plutôt que d'afficher une fausse tendance.",
      "Nouvel écran « Frais & charges » : note de frais par photo, cagnotte du titulaire, charges fixes.",
      "Sécurité : seules les personnes explicitement autorisées entrent désormais dans l'app.",
      "Une facture qui arrive à échéance aujourd'hui n'est plus affichée comme dépassée.",
      "Le tri par montant fonctionne enfin — trois colonnes sur cinq ne triaient rien.",
      "L'app se met à jour toute seule ; ce bouton force la mise à jour et ouvre ces nouveautés.",
      "Finition « app native » : plus de rebond élastique ni de bande blanche, encoche et barre d'accueil respectées.",
    ],
  },
];
